import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import ExpenseForm from "./ExpenseForm";
import HomeExpenseForm from "../../home/form/HomeExpenseForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '96vw',
  maxWidth:'380px',
  maxHeight: '90vh',
  overflowY: 'auto',
  m:'1',
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 2,
  py: 4,
};

export default function ModalForm({ open, formType, handleClose }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={!!open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={!!open}>
        <Box sx={style}>
          <Typography variant="h5" gutterBottom>
            Add {formType === "shared_expense" ? "Shared Expense" : "Home Expense"}
          </Typography>
          <br />
          {formType === "shared_expense"
            ? <ExpenseForm handleClose={handleClose} />
            : <HomeExpenseForm handleClose={handleClose} />}
        </Box>
      </Fade>
    </Modal>
  );
}
